import { atom } from 'recoil';

export const contactsPage = atom({
  key: 'contactsPage', // unique ID (with respect to other atoms/selectors)
  default: 1,
  // default value (aka initial value)
});
